'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WebItemTitleInput = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _immutable = require('immutable');

var _immutable2 = _interopRequireDefault(_immutable);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _baseClearableTextField = require('@bibliocommons/base-clearable-text-field');

var _baseClearableTextField2 = _interopRequireDefault(_baseClearableTextField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  value: _react2.default.PropTypes.string,
  handleWebItemPropertyChange: _react2.default.PropTypes.func.isRequired,
  intl: _reactIntl.intlShape.isRequired
};

var WebItemTitleInput = exports.WebItemTitleInput = function (_BcReactComponent) {
  _inherits(WebItemTitleInput, _BcReactComponent);

  function WebItemTitleInput(props) {
    _classCallCheck(this, WebItemTitleInput);

    var _this = _possibleConstructorReturn(this, (WebItemTitleInput.__proto__ || Object.getPrototypeOf(WebItemTitleInput)).call(this, props));

    _this.bindAll('handleChange', 'handleClear');
    return _this;
  }

  _createClass(WebItemTitleInput, [{
    key: 'handleChange',
    value: function handleChange(value) {
      this.props.handleWebItemPropertyChange(_immutable2.default.Map({ title: value }));
    }
  }, {
    key: 'handleClear',
    value: function handleClear() {
      this.props.handleWebItemPropertyChange(_immutable2.default.Map({ title: '' }));
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'cp-web-item-title-input' },
        _react2.default.createElement(
          'label',
          { htmlFor: 'web-item-title-input', id: 'web-item-title-label' },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_website_title' })
        ),
        _react2.default.createElement(_baseClearableTextField2.default, {
          value: this.props.value,
          id: 'web-item-title-input',
          labelledById: 'web-item-title-label',
          maxLength: 4000,
          handleChange: this.handleChange,
          handleClear: this.handleClear,
          inputTestId: 'web-item-title-input',
          hideClearButton: !this.props.value,
          clearButtonSrText: _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'ada_label_clear_title_text' }),
          characterCountSrOnly: true,
          focus: true })
      );
    }
  }]);

  return WebItemTitleInput;
}(_baseBcReactComponent2.default);

WebItemTitleInput.propTypes = propTypes;
exports.default = (0, _reactIntl.injectIntl)(WebItemTitleInput);


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/web-item-title-input/components/WebItemTitleInput.component.js
// module id = 1359
// module chunks = 0